import { Injectable } from '@angular/core';
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { InfoFirmaDTO } from "@app/shared/dto/protocollo/info-firmaDTO";
import { InfoFirmaVO } from "@app/shared/vo/info-firmaVO";
import { MapperInfoCertificato } from "@app/shared/mapper/edocumento/mapper-info-certificato";
import { InfoCertificatoVO } from "@app/shared/vo/info-certificatoVO";
import { InfoCertificatoDTO } from "@app/shared/dto/protocollo/info-certificatoDTO";

@Injectable({
    providedIn: "root"
})
export class MapperInfoFirma implements MapperInterface<InfoFirmaDTO, InfoFirmaVO> {

    constructor(private mapperInfoCertificato: MapperInfoCertificato) { }


    convertVoToDto(e: InfoFirmaVO): InfoFirmaDTO {
        throw new Error('Method not implemented.');
    }
    convertDtoToVo(t: InfoFirmaDTO): InfoFirmaVO {
        throw new Error('Method not implemented.');
    }
    convertListVoToDto(infoFirmaVO: InfoFirmaVO[]): InfoFirmaDTO[] {
        console.log("[MapperInfoFirma] InfoFirmaVOList => InfoFirmaDTOList", InfoFirmaVO);
        let infoFirmaDTO = new Array<InfoFirmaDTO>();
        let infoFirma = new InfoFirmaDTO();
        let infoCertificatoDTO = new Array<InfoCertificatoDTO>();

        infoFirmaVO.forEach(element => {

            infoFirma.signingTime = element.signingTime;
            infoFirma.level = element.level;
            element.certificateInfos.forEach(certificateInfo => {
                infoCertificatoDTO.push(this.mapperInfoCertificato.convertVoToDto(certificateInfo));

            });
            infoFirma.certificateInfos = infoCertificatoDTO;
            infoFirmaDTO.push(infoFirma);
        });

        return infoFirmaDTO || new Array<InfoFirmaDTO>();

    }

    convertListDtoToVo(infoFirmaDTO: InfoFirmaDTO[]): InfoFirmaVO[] {
        console.log("[MapperInfoFirma] InfoFirmaDTOList => InfoFirmaVOList", infoFirmaDTO);
        let infoFirmaVO:InfoFirmaVO[];
        let infoFirma :InfoFirmaVO;
        let infoCertificatoVO:InfoCertificatoVO[];
        if (infoFirmaDTO != null) {  
            infoFirmaVO = new Array<InfoFirmaVO>();         
            infoFirmaDTO.forEach(element => { 
               
                infoFirma = new InfoFirmaVO();     
                infoFirma.certificateInfos = new Array<InfoCertificatoVO>();                      
                infoFirma.signingTime = element.signingTime;
                infoFirma.level = element.level;
                infoCertificatoVO = new Array<InfoCertificatoVO>();
                element.certificateInfos.forEach(certificateInfo => {  
                    let infoCert:InfoCertificatoVO =this.mapperInfoCertificato.convertDtoToVo(certificateInfo)    ;
                
                    infoCertificatoVO.push(infoCert);
                });
                infoFirma.certificateInfos = infoCertificatoVO;
                infoFirmaVO.push(infoFirma);
            });
        }
        console.log("MapperInfoFirma",infoFirmaVO)    ;      
        return infoFirmaVO || new Array<InfoFirmaVO>();

    }
}

